import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getSelectedDateFromRouter } from 'src/selectors/signals';
import { getDateTicks } from '@sparkpost/report-builder/helpers/date';
import { getDisplayName } from 'src/helpers/hoc';
import _ from 'lodash';

export class WithDetails extends Component {
  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps) {
    const { filters } = this.props;

    // Refresh when filters change
    if (!_.isEqual(prevProps.filters, filters)) {
      this.getData();
    }
  }

  getData = () => {
    const { fetch, facet, facetId, filters, subaccountId } = this.props;

    fetch({
      facet,
      filter: facetId,
      from: filters.from,
      subaccount: subaccountId,
      to: filters.to
    });
  };

  render() {
    const {
      component: WrappedComponent,
      details,
      facet,
      facetId,
      selected,
      subaccountId
    } = this.props;

    // Calculate gap here to share with preview and details
    const gap = details.data && details.data.length > 15 ? 0.2 : 1;

    // The data's dates are used instead of dates in filters because
    // the engagement behavior selectors trim displayed dates
    const xTicks = getDateTicks.useMomentInput({
      from: _.head(details.data).date,
      to: _.last(details.data).date
    });

    return (
      <WrappedComponent
        {...details}
        facet={facet}
        facetId={facetId}
        gap={gap}
        selected={selected}
        xTicks={xTicks}
        subaccountId={subaccountId}
      />
    );
  }
}

/**
 * Provides Signals details to the provided component
 * @example
 *    export default withDetails(MyComponent, { getThisData, getThatData }, selectMyData);
 */
function withDetails(WrappedComponent, fetchData = {}, selectData) {
  const Wrapper = (props) => <WithDetails {...props} component={WrappedComponent} />;

  Wrapper.displayName = getDisplayName(WrappedComponent, 'WithDetails');

  const mapStateToProps = (state, props) => ({
    ...selectData(state, props),
    filters: state.signalOptions,
    selected: getSelectedDateFromRouter(state, props)
  });

  const mapDispatchToProps = (dispatch) => ({
    fetch: (options) => {
      _.forEach(fetchData, (get) => {
        dispatch(get(options));
      });
    }
  });

  return withRouter(connect(mapStateToProps, mapDispatchToProps)(Wrapper));
}

export default withDetails;
